import { LoyaltyPromotionType, LoyaltyServiceRewardType } from 'generated/graphql-gateway';
import { CustomEventNames, EventTypes, logRBIEvent } from 'state/amplitude';
import { getIncentiveDayParts } from 'state/loyalty/hooks/utils/incentives-availability';

import { Reward } from '../types';
import { rewardToLoyaltyReward } from '../utils';

const getRewardDayParts = (reward: Reward): string[] =>
  (getIncentiveDayParts(rewardToLoyaltyReward(reward)) || []).filter(
    (dayPart): dayPart is string => typeof dayPart === 'string'
  );

export const logRewardSelected = (reward: Reward): void => {
  const cmsId = reward.cmsId || '';

  logRBIEvent({
    name: CustomEventNames.REWARD_SELECTED,
    type: EventTypes.Other,
    attributes: {
      dayParts: getRewardDayParts(reward),
      engineId: reward.id,
      incentiveSanityId: cmsId,
      incentiveType: LoyaltyPromotionType.REWARD,
      loyaltyEngineId: reward.id,
      name: reward.name,
      sanityId: cmsId,
      type: reward.type === LoyaltyServiceRewardType.CONFIG ? 'ConfigReward' : 'Reward',
    },
  });
};
